interface TermCountdownProps {
  daysLeft: number
  hoursLeft: number
  termProgress: number
}

export function TermCountdown({ daysLeft, hoursLeft, termProgress }: TermCountdownProps) {
  return (
    <div className="bg-[#284e8c] rounded-3xl p-6 shadow-lg text-white flex flex-col justify-between relative overflow-hidden">
      <div className="absolute -right-4 -top-4 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
      <div className="absolute -left-4 -bottom-4 w-24 h-24 bg-white/5 rounded-full blur-xl"></div>

      <div className="relative z-10">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-6 h-6 rounded-full border-2 border-white/50 flex items-center justify-center">
            <div className="w-3 h-3 bg-white rounded-full"></div>
          </div>
          <h2 className="text-lg font-bold text-blue-100 uppercase tracking-wide">Term Ends In</h2>
        </div>
        <div className="flex items-end gap-2 mt-4">
          <div>
            <span className="text-5xl font-extrabold block leading-none">{daysLeft}</span>
            <span className="text-xs font-medium text-blue-200 uppercase tracking-wider">Days</span>
          </div>
          <div className="pb-2 text-2xl font-light text-blue-300">:</div>
          <div>
            <span className="text-5xl font-extrabold block leading-none">{hoursLeft.toString().padStart(2, "0")}</span>
            <span className="text-xs font-medium text-blue-200 uppercase tracking-wider">Hours</span>
          </div>
        </div>
      </div>

      <div className="mt-6 relative z-10">
        <div className="flex justify-between text-xs font-medium text-blue-200 mb-2">
          <span>Term Progress</span>
          <span>{termProgress}%</span>
        </div>
        <div className="w-full bg-blue-800/50 rounded-full h-3 backdrop-blur-sm">
          <div
            className="bg-white h-3 rounded-full shadow-lg shadow-white/20"
            style={{ width: `${termProgress}%` }}
          ></div>
        </div>
        <p className="text-xs text-blue-200 mt-4 text-center border-t border-white/10 pt-3">
          Next: Mid-Term Break starts Oct 25th
        </p>
      </div>
    </div>
  )
}
